<template>
    <div class="d-flex item">
        <small>{{ count }} {{transChoice(`community.profile.${label}`, count)}}
        </small>
        <span class="separator pl-2 pr-2">|</span>
    </div>
</template>

<script>
export default {
    name: "ProfileCounter",
    props: {
        count: Number,
        label: String
    }
}
</script>

<style scoped lang="scss">
    .item {
        &:last-child {
            .separator {
                display: none;
            }
        }
    }
    .separator {
        font-size: 12px;
    }
</style>
